export const selectedPlayers = [
  {
    title: {
      value: 'tournament',
      name: 'Соревнования',
    },
    options: [
      { 
        value: 'chrb',
        name: 'Чемпионат',
      },
      {
        value: 'krb',
        name: 'Кубок',
      },
    ],
  },
  {
    title: {
      value: 'gender',
      name: 'Пол',
    },
    options: [
      { 
        value: 'male',
        name: 'Мужчины',
      },
      {
        value: 'female',
        name: 'Женщины',
      },
    ],
  },
  {
    title: {
      value: 'division',
      name: 'Дивизион',
    },
    options: [
      { 
        value: 'division1',
        name: 'Дивизион 1',
      },
      {
        value: 'division2',
        name: 'Дивизион 2',
      },
    ],
  },
]